<template>
  <div class="base-search-wrapper" :class="{ shodow: !pure }">
    <slot></slot>

    <div class="btn-group" :class="{ 'no-search-action': !isSearch, 'is-line': isLine }">
      <div class="search-btn flex-center">
        <template v-if="isSearch">
          <slot name="showMore"></slot>
          <el-button type="primary" plain @click="handleSearch" size="small" v-log="{ page: $route.name, page_event: 'c_search' }" v-if="isLog">
            {{ $t('global.query') }}
          </el-button>
          <el-button type="primary" plain @click="handleSearch" size="small" v-else> {{ $t('global.query') }}</el-button>

          <el-button size="small" @click="handleReset" v-if="isReset"> {{ $t('formrulestips.reset') }}</el-button>
        </template>
      </div>
      <div class="flex-center">
        <slot name="btnGroup"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseSearch',
  props: {
    isLog: {
      type: Boolean,
      default: true
    },
    isSearch: {
      type: Boolean,
      default: true
    },
    isReset: {
      type: Boolean,
      default: true
    },
    isLine: {
      type: Boolean,
      default: false
    },
    pure: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    /**
     * @description: 点击搜索按钮触发search事件
     */
    handleSearch() {
      this.$emit('search')
    },
    handleReset() {
      this.$emit('reset')
    }
  }
}
</script>

<style lang="scss" scoped>
.base-search-wrapper {
  padding: 20px 32px 12px 32px;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 12px;
  &.shodow {
    border-radius: 8px;
    background-color: #fff;
  }

  .btn-group {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    flex-grow: 1;
    height: 40px;
    padding-top: 8px;
    &.no-search-action {
      height: 32px;
    }

    .search-btn {
      margin-right: 12px;
    }

    .flex-center {
      display: flex;
      align-items: center;
    }
  }
  .is-line {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/baseSearch.vue